import Contentful from 'contentful'
import { TypeComponentCtaButton } from './component-cta-button'
import type { TypeComponentConditionalDisplay } from '@lib/types/component-conditional-display'

export enum TextInputType {
  Text = 'text',
  Email = 'email',
  Password = 'password',
  Search = 'search',
  Url = 'url',
}

export enum InputValidationType {
  Email = 'email',
  NeverBounceEmail = 'NeverBounce email',
}

export interface TypeComponentTextInputFields {
  internalName: Contentful.EntryFields.Symbol
  name: Contentful.EntryFields.Symbol
  label?: Contentful.EntryFields.Symbol
  placeholder?: Contentful.EntryFields.Symbol
  type?: TextInputType
  isRequired?: Contentful.EntryFields.Boolean
  validationType?: InputValidationType
  helperText?: Contentful.EntryFields.Symbol
  hasLongformText?: Contentful.EntryFields.Boolean
  allowFileUpload?: Contentful.EntryFields.Boolean
  sampleText?: Contentful.EntryFields.Symbol
  maxLength?: Contentful.EntryFields.Integer
  minCharacterLimit?: Contentful.EntryFields.Integer
  anonymousCharacterLimit?: Contentful.EntryFields.Integer
  anonymousCharacterWordLimitCta?: TypeComponentCtaButton
  useWordLimit?: Contentful.EntryFields.Boolean
  conditionalDisplay?: TypeComponentConditionalDisplay
  restrictedValues?: Contentful.EntryFields.Symbol[]
  restrictedValuesErrorMessage?: Contentful.EntryFields.Symbol
  isHidden?: Contentful.EntryFields.Boolean
  hiddenInputValue?: Contentful.EntryFields.Symbol
}

export type TypeComponentTextInput = Contentful.Entry<TypeComponentTextInputFields>
